<!-- <h1 *ngIf="member">{{member.nickName}}</h1> -->

<div class="main">
    <mat-card class="example-card">
        <mat-card-header>
          <div mat-card-avatar class="example-header-image"></div>
          <mat-card-title>{{member.userName}}</mat-card-title>
          <mat-card-subtitle>{{member.city}}, {{member.country}}</mat-card-subtitle>
        </mat-card-header>
        <img mat-card-image src="{{member.photoUrl || '/assets/ugo.jpg'}}" alt="Photo of a Shiba Inu">

        <mat-card-content>
          <span>Age: </span><span>{{member.age}}</span>
        </mat-card-content>
          
          <mat-card-content>
          <span bold>Member Since: </span><span>{{member.created | date}}</span>
          </mat-card-content>

          
        <mat-card-content>
            <span>Last Active: </span><span>{{member?.lastActive | timeago}}</span>
        </mat-card-content>

        <mat-card-content style="color: green" *ngIf="(presence.onlineUsers$ | async)?.includes(member.userName)">
          <div style="display: flex; align-items: center;">
            <mat-icon>person</mat-icon>
            <span>online now</span>
          </div>
         
      </mat-card-content>

        <mat-card-actions>
          <button color="primary" mat-raised-button>LIKE</button>
          <button (click)="changeTab(3)" color="accent" mat-raised-button>Message</button>
        </mat-card-actions>


      </mat-card>

      <mat-card class="example-card2">
        <mat-tab-group #tabRef animationDuration="0ms" color="accent" backgroundColor="primary" (selectedIndexChange)="checkTab()">
              <mat-tab label='About {{member.userName}}'>
                <div class="tab-content">
                    <h4>Description</h4>
                    <p>{{member.introduction}}</p>

                    <h4>Looking for:</h4>
                    <p>{{member.lookingFor}}</p>
                </div>
                   
            </mat-tab>

            <mat-tab label="Interests">
                <div class="tab-content">
                    <h4>Description</h4>
                    <p>{{member.interests}}</p>
                </div>
                
            </mat-tab>

            <mat-tab label="Photos">
                <div class="tab-content">
                    <h4>Photos will go here</h4>
                    <ngx-gallery [options]="galleryOptions" [images]="galleryImages"
                    style="display: inline-block; margin-bottom: 20px; width: 500px;"></ngx-gallery>
                </div>
               
            </mat-tab>

            <mat-tab label="Messages">
                <div class="tab-content">
                    <!-- <app-member-messages [messages]="messages" [username]="member.userName"></app-member-messages> -->

                    <app-member-messages [username]="member.userName"></app-member-messages>
                </div>
                
            </mat-tab>
          </mat-tab-group>
      </mat-card>

      <!-- <button (click)="changeTab(1)">Change</button> -->
</div>
